import { Flex, Skeleton, SkeletonCircle, Stack } from '@chakra-ui/react';
import { Panel } from '#features/ui';

/**
 * Что видно, пока профиль едет.
 *
 * Раньше на этом месте было пусто: маршрут отдаёт управление компоненту, тот приостанавливается
 * на `useSuspenseQuery`, а границы ожидания над ним не было — при сетевом сбое человек сидел
 * перед пустой колонкой между шапкой и подвалом по 15–20 секунд, пока не кончались повторы, и
 * только потом видел экран ошибки. Пустота в этот момент неотличима от «страница сломалась».
 *
 * Форма повторяет настоящую: плита шапки, две колонки тела и ряд плиток игр — чтобы приезд
 * данных не перекладывал страницу заново.
 */
export const ProfileSkeleton = () => (
  <Stack gap={4} w="100%" maxW="1200px" mx="auto" py={4}>
    <Panel
      variant="container"
      display="flex"
      gap={4}
      alignItems="center"
      p={{ base: 4, md: 6 }}
      w="100%"
    >
      <SkeletonCircle size={{ base: '64px', md: '96px' }} flexShrink={0} />
      <Stack gap={2} flex={1} minW={0}>
        <Skeleton height="24px" maxW="220px" />
        <Skeleton height="16px" maxW="160px" />
        <Skeleton height="16px" maxW="280px" />
      </Stack>
    </Panel>

    <Flex gap={4} flexDirection={{ base: 'column', lg: 'row' }} w="100%">
      <Panel variant="container" display="flex" flexDir="column" gap={3} p={4} flex={2} minW={0}>
        <Skeleton height="18px" maxW="120px" />
        <Skeleton height="14px" />
        <Skeleton height="14px" maxW="80%" />
      </Panel>
      <Panel variant="container" display="flex" flexDir="column" gap={3} p={4} flex={1} minW={0}>
        <Skeleton height="18px" maxW="100px" />
        <Skeleton height="14px" maxW="70%" />
      </Panel>
    </Flex>

    <Flex gap={3} w="100%" overflow="hidden">
      {[0, 1, 2, 3].map((index) => (
        <Skeleton key={index} aspectRatio="16 / 9" flex={1} minW="120px" />
      ))}
    </Flex>
  </Stack>
);
